import React, { } from 'react';
import { View, Image } from 'react-native';
import { AppHeader, ButtonWithIcon } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import styles from './styles';
import successImage from '../../../assets/images/success.png';
import { handleWebBrowser } from '../../../config/utils';

const ConfirmedSubscription = ({ navigation }) => (
  <>
    <AppHeader title="Processando Compra" />
    <View style={styles.viewBase}>
      <Image source={successImage} style={styles.image} />
      <AppText style={styles.textTitle}>Leths GO!</AppText>
      <AppText style={styles.textSubTitle}>Nossa equipe vai se comunicar com você para as próximas etapas e liberar seu acesso ao sistema.</AppText>
      <ButtonWithIcon icon="whatsapp" title="Fale com um Consultor" onPress={() => handleWebBrowser('https://wa.me/5511965443925')} />
      <AppButton onPress={() => navigation.navigate('Login', { screen: 'Base' })} label="VOLTAR AO INÍCIO" style={styles.button} labelStyle={styles.textButton} />
    </View>
  </>
);

export default ConfirmedSubscription;
